const apiConfig = {
  // apiUrl: "http://localhost:8081/api/v1",
  apiUrl: " https://api.abiliorealty.com/api/v1",
};

export default apiConfig;
